'use client';

import { useState } from 'react';
import MilestoneSelector from './components/MilestoneSelector';
import ServiceChecklist from './components/ServiceChecklist';
import { getMilestoneServices } from './utils/milestoneRules';
import Icon from '@/components/ui/AppIcon';
import Header from '@/components/common/Header';
import Footer from '@/app/home-page/components/Footer';

export default function MilestonesPage() {
  const [selectedMake, setSelectedMake] = useState<string>('Lexus');
  const [selectedModel, setSelectedModel] = useState<string>('NX300h');
  const [selectedYear, setSelectedYear] = useState<number>(2016);
  const [selectedMileage, setSelectedMileage] = useState<number>(90000);
  
  const recommendation = getMilestoneServices(selectedMake, selectedModel, selectedYear, selectedMileage);

  const handleSelect = (make: string, model: string, year: number, mileage: number) => {
    setSelectedMake(make);
    setSelectedModel(model);
    setSelectedYear(year);
    setSelectedMileage(mileage);
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Header />
      <div className="flex-1 py-12 md:py-20">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-full mb-4">
            <Icon name="ClipboardDocumentCheckIcon" size={32} className="text-primary" />
          </div>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-text-primary mb-4">
            Milestone Service Guide
          </h1>
          <p className="text-lg text-text-secondary font-body max-w-2xl mx-auto">
            Find out exactly what your car needs at its next service interval. Avoid unnecessary upsells and take control of your vehicle's maintenance.
          </p>
        </div>

        <div className="space-y-12">
          <MilestoneSelector onSelect={handleSelect} />
          
          <ServiceChecklist 
            make={selectedMake} 
            model={selectedModel}
            year={selectedYear}
            mileage={selectedMileage} 
            recommendation={recommendation} 
          />
        </div>

      </div>
      </div>
      <Footer />
    </div>
  );
}
